import { getAmplifyToken, getAmplifyTokenPromise } from "./AmplifyHelp";
import { ErrorObject } from "./generalHelp";

/**
 * function used for download a docusign document with envelope_id and document_id then passing it to callback
 * @param {String} envelope_id docusign envelope id
 * @param {responseHandler} callback callback function to pass document to
 * @param {Number} document_id document id that is being requested
 * @category Api Calls
 * @subcategory Docusign
 * @module
 * 
 */
export function downloadDocusign(envelope_id, callback, document_id=1){
  getAmplifyToken(jwt => {
    fetch(`${process.env.REACT_APP_TIMESHEET_API}/con/ds/download/${envelope_id}?document_id=${document_id}`,
    {headers: {"Authorization":jwt}})
    .then(resp => resp.status == 200 ? resp.blob() : undefined)
    .then(blob => callback(blob))
    .catch(err => {console.error(err); callback(undefined)})
  })
}

export function previewDocusign(envelope_id, callback,  return_url=window.location.origin.toString(), abortCont){
  getAmplifyToken((jwt) =>{
    fetch(`${process.env.REACT_APP_TIMESHEET_API}/con/ds/preview`,
    {
      method:'POST',
      body: JSON.stringify({envelope_id:envelope_id, return_url:return_url}),
      headers: { "Content-Type": "application/json", "Authorization": jwt },
      signal: abortCont ? abortCont.signal: undefined
    }).then(resp => resp.json()).then(json=>callback(json))
    .catch(err => handleError(err,callback))
  })
}

const handleError=(err, callback)=>{
  if(err.name !== 'AbortError'){
    console.error(err)
    callback(undefined)
  }
}

export async function weeklyDocusignPromise(resource_id, project_id, ref_date, redirect_url){
  let jwt = await getAmplifyTokenPromise()
  try{
    let resp = await fetch(`${process.env.REACT_APP_TIMESHEET_API}/con/ds/weekly_submit`,
    {
      headers: {Authorization: jwt, "Content-Type": "application/json"},
      method: 'POST',
      body: JSON.stringify({
        resource_id:resource_id,
        project_id: project_id,
        ref_date: ref_date,
        redirect_url: redirect_url
      })
    })
    if(resp.ok){
      return await resp.json()
    }
    return new ErrorObject(resp.status, await resp.text())
  }catch(err){
    return new ErrorObject(500, err)
  }
}